// charactersAllowed は正規表現の文字クラスの中身（例: "a-zA-Z0-9"）で、
// テナント設定（FunctionProperty）由来の自由入力値がそのまま入る。不正な文字
// クラスを渡されると RegExp のコンパイルが例外になり、フォーム全体のバリデー
// ションが止まってしまうため、ここで捕捉して「検証しない」に倒す。
// 空・undefined はここでは有効扱い（必須チェックは別で行う）。
export const containsDisallowedCharacters = (
  value: string | undefined,
  charactersAllowed: string | undefined
): boolean => {
  if (!value) return false
  if (!charactersAllowed) return false
  try {
    return !new RegExp(`^[${charactersAllowed}]+$`).test(value)
  } catch (e) {
    console.warn(
      'Invalid charactersAllowed pattern is configured. Skipped the validation.',
      { charactersAllowed, error: e }
    )
    return false
  }
}
